export enum DeviceStatus {
  PROFILE_UNSET = 'PROFILE_UNSET', // Do not use, needed because of proto3 limitations
  PROFILE_ACTIVATED = ' PROFILE_ACTIVATED',
  PROFILE_BLOCKED = 'PROFILE_BLOCKED',
  PROFILE_DEACTIVATED = 'PROFILE_DEACTIVATED',
}
